import { render, staticRenderFns } from "./VideoChannelPlayer.vue?vue&type=template&id=3eb0f805&scoped=true&"
import script from "./VideoChannelPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoChannelPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0f805",
  null
  
)

export default component.exports